import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { generateSrcSet } from '@/utils/imageUtils';
import parseAsNumber from '@/utils/parseAsNumber';
import { blurhashToImageCssObject } from '@unpic/placeholder';
import { twMerge } from 'tailwind-merge';
const ResizeImage = ({ image, loading = 'lazy', sizes, blurhashEnabled = true, height: rawHeight, width: rawWidth, positioning = 'focal', ...otherProps }) => {
    if (!image.url) {
        return;
    }
    const imageCss = {};
    if (blurhashEnabled && image.blurhashEnabled) {
        imageCss.backgroundImage = blurhashToImageCssObject(image.blurhash).backgroundImage;
    }
    if (positioning === 'focal' && image.imageFocalPoint?.length) {
        const [x, y] = image.imageFocalPoint.split(',');
        const xPercentage = parseAsNumber(x) * 100;
        const yPercentage = parseAsNumber(y) * 100;
        imageCss.objectPosition = `${xPercentage}% ${yPercentage}%`;
    }
    else if (positioning === 'focal') {
        imageCss.objectPosition = '50% 50%';
    }
    const height = parseAsNumber(rawHeight);
    const width = parseAsNumber(rawWidth);
    const baseUrl = image.url;
    const srcSets = generateSrcSet({
        useCdn: image.useCdn,
        baseUrl,
        focalPoint: image.imageFocalPoint,
        sizes,
    });
    /*
     * Eager Loading:
     * - loading="eager" = Default behavior.
     * - decoding="sync" = Ensures the browser finishes decoding image before rendering anything else
     * - fetchPriority="high" = Forces image to be a high-priority resource before the browser realises it is in view
     *
     * Lazy Loading:
     * - loading="lazy" = Only fetch image when it enters the viewport.
     * - decoding="async" = Default behavior.
     * - fetchPriority="auto" = Default behavior.
     */
    const img = (_jsx("img", { ...otherProps, className: twMerge(positioning === 'focal' && 'object-cover', 'bg-cover', otherProps.className), alt: image.altText ?? '', "data-testid": "optiImage", decoding: loading === 'eager' ? 'sync' : 'async', fetchpriority: loading === 'eager' ? 'high' : 'auto', loading: loading, role: image.altText ? undefined : 'presentation', src: image.resize ? srcSets[0].src : baseUrl, style: imageCss, width: width || undefined, height: height || undefined }));
    if (!image.resize) {
        return img;
    }
    return (_jsxs("picture", { children: [srcSets.map(({ id, media, src, srcHdpi, type }) => (_jsx("source", { media: media, srcSet: `${src}, ${srcHdpi} 2x`, type: type }, id))), img] }));
};
export default ResizeImage;
